export var types = {
    FORM_TEMPLATES_RETRIEVING: 'retrievingFormTemplates',
    FORM_TEMPLATES_RETRIEVED: 'formTemplatesRetrieved',
    FORM_TEMPLATE_DELETED: 'formTemplateDeleted',
    FORM_TEMPLATE_CREATED: 'formTemplateCreated',
    FORM_TEMPLATE_UPDATED: 'formTemplateUpdated',
};
export var mutations = {
    retrievingFormTemplates: function (state) {
        state.loading = true;
    },
    formTemplatesRetrieved: function (state, payload) {
        state.formTemplates = payload.formTemplates;
        state.loading = false;
    },
    formTemplateDeleted: function (state, payload) {
        if (payload.formTemplate.version === 2) {
            return state.formTemplates = state.formTemplates.filter(function (template) { return template.id !== (payload.formTemplate).id; });
        }
        state.formTemplates = state.formTemplates.filter(function (template) { return template.uuid !== payload.formTemplate.uuid; });
    },
    formTemplateCreated: function (state, payload) {
        state.formTemplates.push(payload.formTemplate);
    },
    formTemplateUpdated: function (state, payload) {
        var indexOfTemplate = state.formTemplates.findIndex(function (template) { return template.uuid === payload.formTemplate.uuid; });
        state.formTemplates[indexOfTemplate] = payload.formTemplate;
    },
};
